import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAnnotationSkipped = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			x: 2,
			y: 2,
			width: 20,
			height: 20,
			rx: 4,
			fill: "currentColor",
			fillOpacity: .2
		}),
		/* @__PURE__ */ _jsx("mask", {
			id: "mask0_1972_16465",
			style: { maskType: "alpha" },
			maskUnits: "userSpaceOnUse",
			x: 5,
			y: 5,
			width: 14,
			height: 14,
			children: /* @__PURE__ */ _jsx("rect", {
				x: 5,
				y: 5,
				width: 14,
				height: 14,
				rx: 7,
				fill: "currentColor"
			})
		}),
		/* @__PURE__ */ _jsxs("g", {
			mask: "url(#mask0_1972_16465)",
			children: [
				/* @__PURE__ */ _jsx("rect", {
					x: 5,
					y: 5,
					width: 14,
					height: 14,
					rx: 7,
					fill: "currentColor",
					fillOpacity: .3
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 6,
					y: 6,
					width: 12,
					height: 12,
					rx: 6,
					stroke: "currentColor",
					strokeOpacity: .3,
					strokeWidth: 2
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M7 7L17 17",
					stroke: "currentColor",
					strokeWidth: 2
				})
			]
		})
	]
});
const ForwardRef = forwardRef(SvgAnnotationSkipped);
export { ForwardRef as ReactComponent };
